import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import { Base64Service } from 'src/app/core/base64.service';
import { UserService } from 'src/app/core/user.service';
import { ValidateService } from 'src/app/core/validate.service';
import { ErrCode, User, UserInfoSetApiInput, UserInfoSetApiOutput } from 'src/app/shared/models';
import { B64Pipe } from 'src/app/shared/pipes/b64.pipe';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-dialog-display-name',
  templateUrl: './dialog-display-name.component.html',
  styleUrls: ['./dialog-display-name.component.scss']
})
export class DialogDisplayNameComponent implements OnInit {

  @Input() user: User;
  @Input() showNameDialog: boolean;
  @Output() showNameDialogChange = new EventEmitter<boolean>();
  public displayName: string;
  public errcode: ErrCode;
  public isSaveButtonLoading: boolean = false;
  public nameLengthError: string = '';
  nameLength = 64;

  constructor(
    public b64Pipe: B64Pipe,
    private api: ApiService,
    private base64: Base64Service,
    private userService: UserService,
    private validateService: ValidateService,
    private snackbarService: SnackbarService,
  ) { }

  ngOnInit(): void {
    this.displayName = this.b64Pipe.transform(this.user.display_name);
  }

  getDisplayName = (displayName: string) => {
    this.displayName = displayName;
    this.validLength(displayName);
  }

  validLength(name: string): string {
    if (name.length <= 1 || name.length > this.nameLength) {
      this.nameLengthError = 'Enter a name between 1 and 64 characters long.'
    } else {
      this.nameLengthError = '';
    }
    return this.nameLengthError
  }

  saveName = async () => {
    this.isSaveButtonLoading = true;
    try {
      if (!this.validateService.isDisplayNameValid(this.displayName)) {
        throw { code: 1659 };
      }
      await this.api.execute<UserInfoSetApiOutput>('userinfoset', <UserInfoSetApiInput>{
        display_name_b64: this.base64.encode(this.displayName)
      });
      this.userService.refresh();
      this.isSaveButtonLoading = false;
      this.snackbarService.showMessage("success", "Name updated.");
      this.closeNameDialog();
    } catch (ex) {
      this.isSaveButtonLoading = false;
      console.error(ex);
      this.errcode = ErrCode.fromException(ex);
      if (!this.errcode.msg || this.errcode.msg === 'An unknown error occurred') {
        this.closeNameDialog();
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
    }
  }

  closeNameDialog = () => {
    this.showNameDialog = false;
    setTimeout(() => { 
      this.showNameDialogChange.next(false);
    });
  }
}
